export type MovementType = 'arrival' | 'departure'
export type MovementStatus = 'completed' | 'active' | 'upcoming' | 'inbound'

export interface ScheduleEntry {
  id: string
  tailNumber: string
  aircraftType: string
  time: string          // HH:mm
  type: MovementType
  status: MovementStatus
  client: string
  origin?: string
  destination?: string
  isHero?: boolean
}

/** Today's schedule at Opa-Locka. Times relative to "now" = ~15:30 */
export const SCHEDULE_ENTRIES: ScheduleEntry[] = [
  // Completed movements (earlier today)
  { id: 'sch-1', tailNumber: 'N350KA',  aircraftType: 'King Air 350',      time: '07:15', type: 'departure', status: 'completed', client: 'SunCoast Charter', destination: 'KDAB' },
  { id: 'sch-2', tailNumber: 'N300PE',  aircraftType: 'Phenom 300E',       time: '08:30', type: 'arrival',   status: 'completed', client: 'Atlantic Air',    origin: 'KTEB' },
  { id: 'sch-3', tailNumber: 'N525CJ',  aircraftType: 'Citation CJ4',      time: '09:00', type: 'departure', status: 'completed', client: 'Gulf Aviation',   destination: 'KSRQ' },
  { id: 'sch-4', tailNumber: 'N525XL',  aircraftType: 'Citation XLS+',     time: '10:45', type: 'arrival',   status: 'completed', client: 'KeyBiscayne Exec', origin: 'KMIA' },
  { id: 'sch-5', tailNumber: 'N350CS',  aircraftType: 'Challenger 350',    time: '11:20', type: 'arrival',   status: 'completed', client: 'Coral Gables Air', origin: 'KCLT' },
  // Active / near now
  { id: 'sch-6', tailNumber: 'N12NGX',  aircraftType: 'Pilatus PC-12',     time: '15:10', type: 'departure', status: 'active',    client: 'Island Hopper',   destination: 'MYGF' },
  // Upcoming today
  { id: 'sch-7', tailNumber: 'N280GS',  aircraftType: 'Gulfstream G280',   time: '16:30', type: 'departure', status: 'upcoming',  client: 'Brickell Capital', destination: 'KPBI' },
  { id: 'sch-8', tailNumber: 'N420HJ',  aircraftType: 'HondaJet Elite II', time: '17:45', type: 'departure', status: 'upcoming',  client: 'Keys Air',         destination: 'KEYW' },
  // Hero aircraft — inbound, requesting overnight hangar
  {
    id: 'sch-hero',
    tailNumber: 'C-GBLR',
    aircraftType: 'Global 7500',
    time: '18:15',
    type: 'arrival',
    status: 'inbound',
    client: 'Azure Sky Group',
    origin: 'CYYZ',
    isHero: true,
  },
  // Tomorrow early
  { id: 'sch-9', tailNumber: 'N350KA',  aircraftType: 'King Air 350',      time: '06:00', type: 'departure', status: 'upcoming',  client: 'SunCoast Charter', destination: 'KDAB' },
]

/** Current demo time (shown as "now" marker) */
export const DEMO_NOW_TIME = '15:30'
